console.log('✅ listing-page-component.js loaded successfully!');


import { appState } from '../../js/state.js';

import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';

import {  isNodeEnvironment} from '../../js/utils-fetch-data-json.js';


import {  fetchBlogCategoryByCategoryID,  fetchGetAllFeaturedArticlesByBlogCategoryIDForBlogCategoryPage,  fetchGetAllRecentArticlesByBlogCategoryIDForBlogCategoryPage,
} from '../../services/data-services/blog-data-service.js';

import { buildComponentBlogCardArticle } from './blog-card-article.js';
import { buildComponentBlogCategoriesSide } from './blog-categories-side.js';
import { convertDateToStringAndFormatForLanguage,} from '../../js/utils-convert-numbers.js';
import { buildComponentSubscribeNewsletterWide } from '../newsletter/subscribe-newsletter-wide.js';
import { updateBlogTopNavSelectedHighlightToSelectedListeners } from './blog-top-nav.js';

export async function buildComponentBlogCategory(params) {
  console.log(
      `🔄 Building Component: buildComponentBlogCategory - lang: ${appState.SiteLanguageCookie}  params ${params}`
  );

    try {

        const skeleton = await buildPageSkeleton();

        registerEventListenerToAttach(async () => initbuildComponentBlogCategory(params));
       // registerEventListenerToAttach(initComponentBlogCategory);


        if (!isNodeEnvironment()) return skeleton;

        return await buildActualContent(params);


    //let htmlToRender = '';

    //if (isNodeEnvironment()) {
    //  htmlToRender = await buildActualContent(params);
    //} else {
    //  htmlToRender = await buildPageSkeleton();
    //}

    //const html = `
      


    //${htmlToRender}

      


    //    `;

    //console.log('✅ buildComponentBlogCategory built successfully.');

    //// // Register event listeners
    //// // registerEventListenerToAttach(attachEventListenersCatalogProducts);
    //registerEventListenerToAttach(async () => initComponentBlogCategory(params));

    return html;
  } catch (err) {
    console.error('❌ Error building buildComponentBlogCategory:', err);
    return '<div>Error loading buildComponentBlogCategory </div>';
  }
}

export async function buildPageSkeleton() {
  // Top two “featured” cards
  const topCardsSkeletonHtml = `
      <br />
    <div class="grid-blog-home-bottom-section-card my-fake-image-height-250">
        <div class="my-site-lazy-loading-card">
            <div class="my-site-lazy-loading-card-movement"></div>
        </div>
    </div>
  `;

  const topCardsSkeletonHtml2 = `
    <div class="grid-blog-category-home-featured-top-card my-fake-image-height-400">
        <div class="my-site-lazy-loading-card">
            <div class="my-site-lazy-loading-card-movement"></div>
        </div>
    </div>
    `;

  let middleCardsSkeleton = '';
  for (let i = 0; i < 4; i++) {
    middleCardsSkeleton += `
      <div class="grid-blog-home-featured-middle-section-card my-fake-image-height-400">
                                    <div class="my-site-lazy-loading-card">
                                        <div class="my-site-lazy-loading-card-movement"></div>
                                    </div>
                                </div>

                       
    `;
  }

  // Sidebar section: repeat 5 times
  let sideBarCardsSkeleton = '  <br>  <br>';
  for (let i = 0; i < 5; i++) {
    sideBarCardsSkeleton += `
                <div class="grid-blog-home-bottom-section-card my-fake-image-height-125">
                            <div class="my-site-lazy-loading-card">
                                <div class="my-site-lazy-loading-card-movement"></div>
                            </div>
                        </div>

                        <br />

    `;
  }

  // Middle section: repeat 6 times
  let bottomCardsSkeleton = '';
  for (let i = 0; i < 6; i++) {
    bottomCardsSkeleton += `
     <div class="grid-blog-home-bottom-section-card my-fake-image-height-400">
                        <div class="my-site-lazy-loading-card">
                        <div class="my-site-lazy-loading-card-movement"></div>
                    </div>
                </div>
    `;
  }

  const html = `
    <div id="placeholder-buildComponentBlogCategory">
  
     <div class="blog-breadcrumb-section-wide-wrapper">
        
                   <br>
                <br>
                <br>
                <br>
          
    </div>

    <center>

    <div class="myPageMargins">

        <div class="grid-blog-home-middle-section">

                <div>
                    <div class="grid-blog-category-home-featured-top">

                     ${topCardsSkeletonHtml2}
                     </div>

                      <div class="grid-blog-home-featured-middle-section">

                        ${middleCardsSkeleton}

                        </div>

                 </div>
                 <div class="my-blog-category-side-nav-container">   ${sideBarCardsSkeleton} </div>

        </div>


    </div>

    </center>


        <div class="recent-articles-wide-wrapper">
        <center>
            <div class="myPageMargins">

             <div class="grid-blog-home-bottom-section">

             ${bottomCardsSkeleton}


               </div>

            </div>
            
        </center>
        </div>

         </div>
    
   
  `;

  return html;
}

export async function buildActualContent(params) {
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "my-translator-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  const {
    keyRecentArticles: lblRecentArticles,
    keyBlogCategoryNotFoundMessage: lblBlogCategoryNotFoundMessage,
    keyHome: lblHome,
    keyBlogCategories: lblBlogCategories,
    keyBlogHome: lblBlogHome,
    keyBlogCategory: lblBlogCategory,
  } = _tempTextTranslator;

  const {
    keyBlog: linkBlog,
    keyBlogCategories: linkBlogCategories,
    keyBlogCategory: linkBlogCategory,
  } = _tempLinksTranslator;

  //http://localhost:3000/en/blog/22/factory-life

  //get the values from the params
  const valuesNeeded = params?.split(',') || '';
  let selectedBlogCategoryID = valuesNeeded[1] || 0;
  let categorySEOPageName = valuesNeeded[2];

  //  alert("selectedBlogCategoryID: " + selectedBlogCategoryID);

  const blogCategory = await fetchBlogCategoryByCategoryID(selectedBlogCategoryID);

  //alert("blogCategory: " + JSON.stringify(blogCategory));

  if (!blogCategory || blogCategory.articleCategoryID <= 0 || !blogCategory.articleCategoryID) {
    console.log('❌ Error: Article category not found');
    return buildAritcleCategoryNotFoundPage(lblBlogCategoryNotFoundMessage);
  }

  const dtAPIResultFeaturedArticles = await fetchGetAllFeaturedArticlesByBlogCategoryIDForBlogCategoryPage(
    selectedBlogCategoryID
  );

  const dtAPIResultRecentArticles = await fetchGetAllRecentArticlesByBlogCategoryIDForBlogCategoryPage(
    selectedBlogCategoryID
  );

  const breadCrumbHTML = await renderBreadCrumbHTML(
    blogCategory,
    linkBlog,
    linkBlogCategories,
    lblBlogHome,
    lblBlogCategories
  );

  const topFeaturedAreaHTML = await renderTopFeaturedAreaHTML(
    dtAPIResultFeaturedArticles,
    linkBlog
  );

  const remainingMiddleFeaturedAreaHTML = await renderRemainingMiddleFeaturedAreaHTML(
    dtAPIResultFeaturedArticles,
    linkBlog
  );

  const recentArticlesAreaHTML = await renderRecentArticlesAreaHTML(
    dtAPIResultRecentArticles,
    linkBlog
  );

  const recentArticlesTitileAreaHTMLFinal =
    dtAPIResultRecentArticles.length > 0
      ? `<div class="grid-blog-home-bottom-section-card"><h2>${lblRecentArticles}</h2></div>`
      : '';

  const blogCategoriesSideForSide = await buildComponentBlogCategoriesSide();

  //const cartRowsHTML = (cartItems?.length > 0) ? await renderCartRows(dtAPIResultFeaturedArticles) : renderEmptyCart();

  //const cartBottomSummaryHTML = (cartItems?.length > 0) ? await renderCartBottomSummarySection(dtAPIResultFeaturedArticles) : "";

  const emptyCartHTML = '';

  const html = `
      
          <div class="blog-breadcrumb-section-wide-wrapper">

              ${breadCrumbHTML}
          
    </div>

    <center>

    <div class="myPageMargins">

        <div class="grid-blog-home-middle-section">

                <div>
                    <div class="grid-blog-category-home-featured-top">

                     ${topFeaturedAreaHTML}
                     </div>

                      <div class="grid-blog-home-featured-middle-section">

                        ${remainingMiddleFeaturedAreaHTML}

                        </div>

                 </div>
                 <div class="my-blog-category-side-nav-container">   ${blogCategoriesSideForSide} </div>

        </div>


    </div>

    </center>


        <div class="recent-articles-wide-wrapper">
        <center>
            <div class="myPageMargins">

          ${recentArticlesTitileAreaHTMLFinal}

             <div class="grid-blog-home-bottom-section">

             ${recentArticlesAreaHTML}


               </div>

            </div>
            
        </center>
        </div>
    






        `;

  return html;
}

export async function initbuildComponentBlogCategory(params) {
  try {
    //console.log('✅ buildComponentBlogCategory event listeners attached.');

    //let htmlToRender = await buildActualContent(params);

    //const currentPlacholder = document.querySelector('#placeholder-buildComponentBlogCategory');
    //if (currentPlacholder) {
    //  currentPlacholder.innerHTML = htmlToRender;
    //}

    //updateBlogTopNavSelectedHighlightToSelectedListeners();


      const container = document.querySelector("#placeholder-buildComponentBlogCategory");
      if (!container) return;


      container.outerHTML = await buildActualContent(params);



  } catch (error) {
    console.error('❌ Error attaching event listeners to buildComponentBlogCategory:', error);
  }
}

export async function renderBreadCrumbHTML(
  blogCategory,
  linkBlog,
  linkBlogCategories,
  lblBlogHome,
  lblBlogCategories
) {
  const html = `


    
        <center>
            <div class="myPageMargins">
                <div class="grid-blog-category-breadcrumb-links-section">



                    <div class="breadcrumb-item"><a href="${linkBlog}">${lblBlogHome}</a></div>
                    <div class="breadcrumb-item-divider"> / </div>
                     <div class="breadcrumb-item"><a href="${linkBlogCategories}">${lblBlogCategories}</a></div>
                    <div class="breadcrumb-item-divider"> / </div>
                    <div class="breadcrumb-item-active">  ${blogCategory.name}   </div>



                </div>
                <h1 class="grid-blog-category-breadcrumb-section-h1"> ${blogCategory.name}</h1>
            </div>
        </center>
  


       

                        `;

  return html;
}

export async function renderTopFeaturedAreaHTML(dtAPIResultFeaturedArticles, linkBlog) {
  const topTwoData = dtAPIResultFeaturedArticles?.slice(0, 1) || [];

  const html = topTwoData
    .map(item => {
      const currentNavLink = `${linkBlog}/${item.defaultArticleCategoryID}/${item.defaultArticleCategorySEOPageName}/${item.articleID}/${item.seoPageName}`;

      const date = convertDateToStringAndFormatForLanguage(
        item.dateCreated,
        'MMMM dd, yyyy',
        appState.SiteLanguageCookie
      );

      //            new Date(item.dateCreated).toLocaleDateString(appState.SiteLanguageCookie, { month: 'long', day: '2-digit', year: 'numeric' });

      // convertDateToStringAndFormatForLanguage(@item.DateCreated, "MMMM dd, yyyy", _myUserIdentityInformationService.SiteLanguageCookie)

      const container = `

         <a href="${currentNavLink}">
                    <div class="grid-blog-home-featured-top-card">



                            <img src="${item.image1FileName}" alt="${item.title}" width="625" height="420" />



                    <div class="grid-blog-home-featured-top-card-info-wrapper">

                            <span class="grid-blog-home-info-badge"> ${item.defaultArticleCategoryName}</span>
                            <span class="grid-blog-home-info-date"> ${date}  </span >
                               

                        <h2 class="grid-blog-home-featured-top-card-info-h2">
                                ${item.title}
                            </h2>


                    </div>

                </div>
            </a>


       

                `;

      return container;
    })
    .join('');

  return html;
}

export async function renderRemainingMiddleFeaturedAreaHTML(dtAPIResultFeaturedArticles, linkBlog) {
  const restExceptTopTwoData = dtAPIResultFeaturedArticles?.slice(1) || [];

  const html = restExceptTopTwoData
    .map(item => {
      const currentNavLink = `${linkBlog}/${item.defaultArticleCategoryID}/${item.defaultArticleCategorySEOPageName}/${item.articleID}/${item.seoPageName}`;

      const date = convertDateToStringAndFormatForLanguage(
        item.dateCreated,
        'MMMM dd, yyyy',
        appState.SiteLanguageCookie
      );

      //            new Date(item.dateCreated).toLocaleDateString(appState.SiteLanguageCookie, { month: 'long', day: '2-digit', year: 'numeric' });

      // convertDateToStringAndFormatForLanguage(@item.DateCreated, "MMMM dd, yyyy", _myUserIdentityInformationService.SiteLanguageCookie)

      const container = buildComponentBlogCardArticle(
        currentNavLink,
        item.image1FileName,
        item.title,
        date,
        item.defaultArticleCategoryName
      );

      //const container = `

      //        `;

      return container;
    })
    .join('');

  return html;
}

export async function renderRecentArticlesAreaHTML(dtAPIResultRecentArticles, linkBlog) {
  const recentArticlesData = dtAPIResultRecentArticles || [];

  const html = recentArticlesData
    .map(item => {
      const currentNavLink = `${linkBlog}/${item.defaultArticleCategoryID}/${item.defaultArticleCategorySEOPageName}/${item.articleID}/${item.seoPageName}`;

      const date = convertDateToStringAndFormatForLanguage(
        item.dateCreated,
        'MMMM dd, yyyy',
        appState.SiteLanguageCookie
      );

      //            new Date(item.dateCreated).toLocaleDateString(appState.SiteLanguageCookie, { month: 'long', day: '2-digit', year: 'numeric' });

      // convertDateToStringAndFormatForLanguage(@item.DateCreated, "MMMM dd, yyyy", _myUserIdentityInformationService.SiteLanguageCookie)

      const container = buildComponentBlogCardArticle(
        currentNavLink,
        item.image1FileName,
        item.title,
        date,
        item.defaultArticleCategoryName
      );

      //const container = `

      //        `;

      return container;
    })
    .join('');

  return html;
}

export async function buildAritcleCategoryNotFoundPage(lblBlogCategoryNotFoundMessage) {
  const blogCategoriesSideForSide = await buildComponentBlogCategoriesSide();
  const subscribeNewsletterWideHTML = await buildComponentSubscribeNewsletterWide();

  const html = `

  

    <div class="my-blog-hero-div-wrapper">

       
    </div>

  <center>
    <div class="myPageMargins">
        <div class="blog-flex-row">

            <div class="blog-flex-column-main-content">
            <br />
            <div>
                            <br /><br /><br /><br />
                            ${lblBlogCategoryNotFoundMessage}
                            <br /><br /><br /><br />
            </div>

            <br /><br /><br /><br />
              ${subscribeNewsletterWideHTML}

            </div>
             <div class="blog-flex-column-sidebar-content">
              <br /> 
                     <br /> 


            ${blogCategoriesSideForSide}

             </div>
        </div>
    </div>
</center>


<br>
<br>
<br>
<br>
    
   
  `;

  return html;
}

export async function buildComponentBlogCategoryHeaderTags(params) {
  //import { fetchBlogCategoryByCategoryID, fetchGetAllFeaturedArticlesByBlogCategoryIDForBlogCategoryPage, fetchGetAllRecentArticlesByBlogCategoryIDForBlogCategoryPage } from "../../services/data-services/blog-data-service.js";
  // 1. Kick off *all* dynamic imports at once, including your component
  const [{ fetchGetBlogCategorySEOTagsByCategoryID }] = await Promise.all([
    import(
      /* webpackChunkName:"blog-data-service", webpackPrefetch: true */ '../../services/data-services/seo-data-service.js'
    ),
  ]);

  let result = '';

  //get the values from the params
  const valuesNeeded = params?.split(',') || '';
  let selectedBlogCategoryID = valuesNeeded[1] || 0;
  let categorySEOPageName = valuesNeeded[2];

  const currentPageSEOAPIResult = await fetchGetBlogCategorySEOTagsByCategoryID(
    selectedBlogCategoryID
  );

  //alert("blogCategory: " + JSON.stringify(blogCategory));

  if (!currentPageSEOAPIResult) {
    console.log('❌ Error: seo Blog Article category not found');

    return result;
  }

  result = currentPageSEOAPIResult;

  return result;
}
